import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import HyperlinkContainer from './HyperlinkContainer';

const left = css({ textAlign: 'left' });
const Hyperlink = props => {
  const { element, nameSpace } = props;
  const { formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const eventProps = makeEventProps(element.data.events, nameSpace);

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle, elementAttributes }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-input', left)}
            {...formSettings}
          >
            <HyperlinkContainer
              element={element}
              elementId={element.id}
              getAllClasses={getAllClasses}
              elementStyle={elementStyle}
              elementAttributes={elementAttributes}
              {...eventProps}
              className={className}
            />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Hyperlink;
